import React, { useState } from 'react';
import { Drawer, IconButton, AppBar, Toolbar, Typography, Box } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SellerDrawerList from '../../components/SellerDrawerList/SellerDrawerList';
import SellerRoutes from '../../../Routes/SellerRoutes';

export default function SellerDashboard() {
    const [mobileOpen, setMobileOpen] = useState(false);

    const toggleDrawer = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <Box className="min-h-screen bg-slate-50 flex flex-col">
            {/* Mobile Top Navbar */}
            <AppBar position="sticky" elevation={0} className="bg-slate-900 border-b border-slate-800 lg:hidden">
                <Toolbar className="flex justify-between">
                    <Typography variant="h6" className="text-teal-400 font-bold">
                        POWER TOOLS
                    </Typography>
                    <IconButton edge="start" color="inherit" onClick={toggleDrawer} aria-label="menu">
                        <MenuIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            {/* Mobile Drawer */}
            <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={toggleDrawer}
                ModalProps={{ keepMounted: true }}
                className="lg:hidden"
            >
                <SellerDrawerList toggleDrawer={toggleDrawer} />
            </Drawer>

            {/* Main Content Layout */}
            <Box className="flex flex-1 overflow-hidden">
                {/* Desktop Permanent Drawer */}
                <Box component="aside" className="hidden lg:block h-[calc(100vh-0px)] sticky top-0">
                    <SellerDrawerList />
                </Box>

                {/* Main Dynamic View */}
                <Box component="main" className="flex-1 p-6 lg:p-10 overflow-y-auto max-w-7xl mx-auto">
                    <SellerRoutes />
                </Box>
            </Box>
        </Box>
    );
}